import React from "react";
import AppShell from "./components/layout/AppShell";

export default function App() {
  return <AppShell />;
}
